<template>
  <div>
    <div
      style="background-color: white; padding: 20px 20px; text-align: justify"
    >
      <span style="font-size: 20px; font-weight: bolder"
        >PerturbDB collected information from various databases to annotate
        perturbed genes.</span
      >
      <br />
      <div>
        <a-list :split="false" style="font-size: 16px; padding-left: 20px">
          1. PerturbDB obtains annotation of main subcellular location of
          proteins based on immunofluorescently stained cells.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="The open access resource for human proteins."
            >
              <a
                slot="title"
                href="https://www.proteinatlas.org/"
                target="_blank"
                >The Human Protein Atlas
              </a>
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/01HPA_gene.png"
              />
            </a-list-item-meta>
          </a-list-item>
          2. PerturbDB obtains annotation of all human RBPs.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="Comprehensive and user-friendly database for eukaryotic RNA binding proteins (RBPs)"
            >
              <a
                slot="title"
                href="http://eurbpdb.gzsys.org.cn/index.php"
                target="_blank"
                >EuRBPDB</a
              >
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/02EuRBPDB_gene.png"
              />
            </a-list-item-meta>
          </a-list-item>
          3. PerturbDB obtains annotation of all human TFs.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="Comprehensive database including classification and annotation of genome-wide 
                        transcription factors (TFs) and transcription cofactors in 183 animal genomes."
            >
              <a
                slot="title"
                href="http://bioinfo.life.hust.edu.cn/AnimalTFDB4/"
                target="_blank"
                >AnimalTFDB4</a
              >
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/03AnimalTFDB4_gene.png"
              />
            </a-list-item-meta>
          </a-list-item>
          <!-- 4. PerturbDB obtains annotation of all human E3 ligases.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="Known and predicted human ubiquitin ligase (E3) - substrate interaction."
            >
              <a
                slot="title"
                href="http://ubibrowser.bio-it.cn/ubibrowser/home/index"
                target="_blank"
                >UbiBrowser</a
              >
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/04ubibrowser_gene.png"
              />
            </a-list-item-meta>
          </a-list-item> -->
          4. PerturbDB obtains annotation of all human Metabolism genes.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="Dataset of 1660 human Metabolism genes."
            >
              <a
                slot="title"
                href="https://www.cell.com/cell-metabolism/fulltext/S1550-4131(20)30545-3?_returnURL=https%3A%2F%2Flinkinghub.elsevier.com%2Fretrieve%2Fpii%2FS1550413120305453%3Fshowall%3Dtrue"
                target="_blank"
                >Pubmed article</a
              >
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/05metabolism_gene.png"
              />
            </a-list-item-meta>
          </a-list-item>
          5. PerturbDB obtains annotation of all human Essential genes.
          <a-list-item style="padding-left: 5%">
            <a-list-item-meta
              description="Empower the research community to make discoveries related to cancer
                         vulnerabilities by providing open access to key cancer dependencies analytical and visualization tools."
            >
              <a slot="title" href="https://depmap.org/portal/" target="_blank"
                >depmap protal</a
              >
              <a-avatar
                slot="avatar"
                src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/06depmap_gene.png"
              />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <div style="text-align: center">
          <img
            width="60%"
            height="60%"
            src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene1.png"
          />
        </div>
        <div>
          <span style="font-size: 20px; font-weight: bolder">
            To facilitate navigation and access to specific information:
          </span>
          <ul style="margin-top: 10px">
            <li>
              1. Use the search function located in the upper left corner by
              entering relevant keywords.
            </li>
            <li>2. Click the Gene symbol to access quick search page.</li>
            <li>
              3. Click the Perturb-seq ID to access the Perturb-Seq gene page
              that show the processing results of scRNA-seq gene perturbation
              data.
            </li>
            <li>
              4. Click the Perturbation Cluster ID to access the detailed result
              of perturbation clusters page.
            </li>
          </ul>
        </div>
        <div>
          <span style="font-size: 20px; font-weight: bolder">
            Let's input a key word, "<i style="color: blue">SIRT7</i>", for
            example:
          </span>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene2.png"
            />
          </div>
          <div style="font-size: 15px; font-weight: bolder; font-size: 18px">
            PerturbDB integrates data from 4 Perturb-Seq datasets for SIRT7.
            Furthermore, it has been identified as a member of 3 perturbation
            clusters.
          </div>
          <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="Perturbation detail page of Perturb-Seq">
              <div
                style="font-size: 15px; font-weight: bolder; font-size: 18px"
              >
                Click the Perturb-Seq ID: "
                <span style="color: blue">SC00004</span> ", you'll go to a new
                page .
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                1. The basic information of the perturbed gene.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene3.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                2. Density plot of perturbation score per cells.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene4.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                3. This module contains the aberrant expression patterns of
                perturbated genes in pan-cancer and their correlation with
                patients' prognosis survival.
              </div>

              <div style="text-align: center">
                <a-tabs>
                  <a-tab-pane
                    key="1"
                    tab="PART I : Differential Expression Analysis"
                  >
                    <img
                      width="60%"
                      height="100%"
                      src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene5_boxplot.png"
                    />
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="PART II : Survival Plots">
                    <img
                      width="60%"
                      height="100%"
                      src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene5_survival.png"
                    />
                  </a-tab-pane>
                  <a-tab-pane
                    key="3"
                    tab="PART III : Gene Expression Profile across All Cancers"
                  >
                    <img
                      width="60%"
                      height="100%"
                      src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene5_pancancer.png"
                    />
                  </a-tab-pane>
                </a-tabs>
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                4. Interactive volcano plot and table of differentially
                expressed genes. PerturbDB offers convenient querying and
                downloading capabilities.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene7.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                5. PerturbDB performed gene set enrichment analysis of
                differential expressed genes, switch the tabs could preview the
                enrichment results of different pathway.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene8.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                6. For Perturb-seq genes, PerturbDB provides the violin plot
                function to show the expression levels of interested gene in
                perturbed cell and controlled cells.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene9.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                7. PerturbDB provides data from the CCLE project, allowing users
                to conveniently query the expression levels of SIRT7 in various
                tumor cell lines.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene10.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                8. PerturbDB provides data from the GTEx project, allowing users
                to conveniently query the expression levels of SIRT7 in normal
                tissue of human.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene11.png"
                />
              </div>
              <div style="margin-left: 15px; font-size: 18px">
                9. Fianlly, PerturbDB enhanced user interaction by adding a
                "sgRNA sequence" section on the gene perturbation details page.
              </div>
              <div style="text-align: center">
                <img
                  width="60%"
                  height="60%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene12.png"
                />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
export default {};
</script>
